import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LoaderSpinner from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../common/DataTable';
import { accountsManagement, featureSubmodulePermission, numOfPage, permssionEdit, SUBF_USER, SUBF_USERREQUESTS, UserRequestColumns } from '../../constant';
import BatchPagination from '../batch/BatchPagination';
import { approveUserSignup, getAllPendingUserList, getWhatsAppMsg, rejectUserSignup, sendPendingUserEmail } from '../../store/actions';
import { toast } from "react-toastify";
import { Button } from 'bootstrap-4-react/lib/components';
import Modal from '@material-ui/core/Modal';
import UserOnboarding from '../UserOnboarding';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import AlertDialogModal from '../common/AlertDialog';
import SearchProduct from '../Inventory/Product/searchProduct';
import { resetUserPasswordToDefaultService } from '../../services/user.service';
import { checkPermission } from '../../config/utils';
import { mapUserRequestRow } from './statusUtils';
import UserRequestFilterPanel from './UserRequestFilterPanel';
import RejectReasonModal from './RejectReasonModal';

/* istanbul ignore next */
const UserRequest = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const cameFromPartnerMgmt = location?.state?.from === 'partner-management';
    const targetPendingSignupId = location?.state?.pendingSignupId;
    const autoOpenedRef = useRef(false);
    const [loader, setLoader] = useState(false);
    const { allPendingUsersDataStatus, allPendingUsersData } = useSelector((state) => state.UsersReducer);
    const [usersList, setUsersList] = useState([]);
    const [showUserRequest, setShowUserRequest] = useState({
        show: false,
        data: null,
        startInEditMode: false,
    });
    const [resetPasswordModal, setResetPasswordModal] = useState({
        show: false,
        item: null,
    });
    const [resetPasswordLoader, setResetPasswordLoader] = useState(false);
    const [rejectModal, setRejectModal] = useState({ show: false, item: null });
    const [rejectLoader, setRejectLoader] = useState(false);
    const employeePermissions = useSelector((state) => state?.sidebar?.employeePermissions);
    const UserValue = useSelector((state) => state.auth.user);
    const canResetPassword = checkPermission(accountsManagement, SUBF_USER, permssionEdit, featureSubmodulePermission, employeePermissions);
    const canEditAccountDetails = Boolean(UserValue?.Value?.isSuperAdmin) && checkPermission(accountsManagement, SUBF_USERREQUESTS, permssionEdit, featureSubmodulePermission, employeePermissions);
    let dispatch = useDispatch();
    let dataLoad = {
        pageIndex: 1,
        pageSize: 30,
        sortColumn: '',
        sortOrder: 'ASCENDING',
        searchkey: '',
        searchKeywords: '',
        companySellerIds: [],
        onboardingStatusIds: [],
    };
    const [filterData, setfilterData] = useState(dataLoad);
    const [searchInput, setSearchInput] = useState('');
    const [showFilter, setShowFilter] = useState(false);
    const [filterSelections, setFilterSelections] = useState({ sellers: [], statuses: [] });
    const debounceTimerRef = useRef(null);

    // Debounce search input → filterData.searchKeywords (≥ 300 ms per spec).
    useEffect(() => {
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = setTimeout(() => {
            setfilterData(prev => ({ ...prev, searchKeywords: searchInput, pageIndex: 1 }));
        }, 300);
        return () => {
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        };
    }, [searchInput]);

    // Enter / Search button: bypass debounce and always re-fire the API.
    const flushSearch = (valueOverride) => {
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        const commit = valueOverride !== undefined ? valueOverride : searchInput;
        if (valueOverride !== undefined) setSearchInput(valueOverride);
        setfilterData(prev => ({
            ...prev,
            searchKeywords: commit,
            pageIndex: 1,
            _searchNonce: (prev._searchNonce || 0) + 1,
        }));
    };

    const handleSearchFilter = (_e, type) => {
        if (type === 'clear') flushSearch('');
        else flushSearch();
    };

    const handleFilterApply = ({ sellers, statuses }) => {
        const companySellerIds = (sellers || [])
            .map(s => s?.value ?? s?.id)
            .filter(v => v !== undefined && v !== null);
        const onboardingStatusIds = (statuses || [])
            .map(s => s?.value ?? s?.id)
            .filter(v => v !== undefined && v !== null);
        setFilterSelections({ sellers: sellers || [], statuses: statuses || [] });
        setfilterData(prev => ({
            ...prev,
            companySellerIds,
            onboardingStatusIds,
            pageIndex: 1,
        }));
    };

    const handleFilterClear = () => {
        setFilterSelections({ sellers: [], statuses: [] });
        setfilterData(prev => ({
            ...prev,
            companySellerIds: [],
            onboardingStatusIds: [],
            pageIndex: 1,
        }));
    };

    const companySellerIdsKey = (filterData.companySellerIds || []).join(',');
    const onboardingStatusIdsKey = (filterData.onboardingStatusIds || []).join(',');

    useEffect(() => {
        fetchAllList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filterData.numberOfPage,
        filterData.pageIndex,
        filterData.pageSize,
        filterData.sortColumn,
        filterData.sortOrder,
        filterData.searchKeywords,
        filterData._searchNonce,
        companySellerIdsKey,
        onboardingStatusIdsKey,
    ]);

    useEffect(() => {
        if (allPendingUsersDataStatus === 'PENDING') {
            setLoader(true);
        } else if (allPendingUsersDataStatus === 'SUCCESS') {
            setLoader(false);
        }
    }, [allPendingUsersDataStatus]);

    useEffect(() => {
        if (allPendingUsersData?.usersList) {
            let addlistIndex = allPendingUsersData?.usersList.map(mapUserRequestRow);
            setUsersList(addlistIndex);
            if (allPendingUsersDataStatus === 'SUCCESS') {
                setfilterData({
                    ...filterData,
                    totalPages: Math.ceil(allPendingUsersData?.TotalRecords / filterData.pageSize),
                });
                // Auto-open the review modal when arriving from Partner Management with a pendingSignupId
                if (!autoOpenedRef.current && targetPendingSignupId) {
                    const match = addlistIndex.find((row) => row?.Id === targetPendingSignupId);
                    if (match) {
                        autoOpenedRef.current = true;
                        setShowUserRequest({ show: true, data: match, startInEditMode: false });
                    }
                }
            }
        }
    }, [allPendingUsersData]);

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            sortColumn: key,
            sortOrder: newSortOrder,
        });
    };

    const handleApprove = async (item) => {
        setLoader(true);
        const signupRes = await approveUserSignup({ pendingSignupId: item.Id });
        if (signupRes?.data?.Status === 200) {
            toast.success('User approved successfully');
        } else {
            toast.error(signupRes?.data?.Message?.AppStatusDescription || 'Failed to approve user');
        }
        setLoader(false);
    };

    const handleReject = async (item, rejectionReason) => {
        setLoader(true);
        const rejectSignupRes = await rejectUserSignup({
            pendingSignupId: item.Id,
            rejectionReason,
        });
        if (rejectSignupRes?.data?.Status === 200) {
            toast.success('Request rejected. Email sent to the user.');
        } else {
            toast.error(rejectSignupRes?.data?.Message?.AppStatusDescription || 'Failed to reject request');
        }
        setLoader(false);
    };

    const openRejectModal = (item) => {
        setRejectModal({ show: true, item });
    };

    const closeRejectModal = () => {
        if (rejectLoader) return;
        setRejectModal({ show: false, item: null });
    };

    const confirmReject = async (reason) => {
        const item = rejectModal.item;
        if (!item) return;
        setRejectLoader(true);
        try {
            await handleReject(item, reason);
            setRejectModal({ show: false, item: null });
            fetchAllList();
        } finally {
            setRejectLoader(false);
        }
    };

    const handleAction = async (item, type) => {
        if (type === 'approve') {
            await handleApprove(item);
            fetchAllList();
            return;
        }
        if (type === 'delete') {
            openRejectModal(item);
            return;
        }
        if (type === 'viewRequest') {
            setShowUserRequest({ show: true, data: item, startInEditMode: false });
            return;
        }
        if (type === 'editAccountDetails') {
            setShowUserRequest({ show: true, data: item, startInEditMode: true });
            return;
        }
        if (type === 'whatsApp') {
            handleWhatsApp(item);
            return;
        }
        if (type === 'sendEmail') {
            handleSendEmail(item);
            return;
        }
        if (type === 'resetPassword') {
            setResetPasswordModal({ show: true, item });
        }
    };

    const handleWhatsApp = async (item) => {
        try {
            setLoader(true);
            let response = await getWhatsAppMsg(item.Id);
            const status = response?.data?.Status;
            const appStatusDesc = response?.data?.Message?.AppStatusDescription || '';
            const isEmailAlreadyVerified = status === 400 && appStatusDesc.trim().toLowerCase() === 'this email is already verified';
            const phoneNum = (item.PhoneNumber || '').replaceAll(/\D/g, ''); // Remove non-digit characters
            if (status === 200) {
                const message = response.data.Entity;
                const whatsappUrl = `https://wa.me/${phoneNum}?text=${encodeURIComponent(message)}`;
                window.open(whatsappUrl, '_blank');
            } else if (isEmailAlreadyVerified) {
                // Email already verified — open WhatsApp with empty message, suppress error toast
                const whatsappUrl = `https://wa.me/${phoneNum}`;
                window.open(whatsappUrl, '_blank');
            } else {
                toast.error(appStatusDesc || 'Failed to get WhatsApp message content');
            }
            setLoader(false);
        } catch (error) {
            console.error('Failed to get WhatsApp message content:', error);
            toast.error('Failed to get WhatsApp message content');
            setLoader(false);
        }
    };

    const handleSendEmail = async (item) => {
        try {
            let response = await sendPendingUserEmail(item.Id);
            if (response?.data?.Status === 200) {
                toast.success('Email sent successfully');
            } else {
                toast.error(response?.data?.Message?.AppStatusDescription || 'Failed to send email');
            }
        } catch (error) {
            toast.error('Failed to send email');
        }
    };

    const closeResetPasswordModal = () => {
        setResetPasswordModal({ show: false, item: null });
    };

    const confirmResetPassword = async () => {
        const item = resetPasswordModal.item;
        if (!item) return;
        try {
            setResetPasswordLoader(true);
            const response = await resetUserPasswordToDefaultService({
                pendingSignupId: item.Id,
            });
            if (response?.data?.Status === 200) {
                toast.success(`Password reset successfully. Email sent to ${item.Email}.`);
                closeResetPasswordModal();
                fetchAllList();
            } else {
                toast.error(
                    response?.data?.Entity ||
                    response?.data?.Message?.AppStatusDescription ||
                    'Failed to reset password'
                );
            }
        } catch (error) {
            console.error('Reset password failed:', error);
            toast.error('Failed to reset password');
        } finally {
            setResetPasswordLoader(false);
        }
    };

    const fetchAllList = () => {
        dispatch(getAllPendingUserList(filterData));
    };

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    User Requests
                    <div className="top_right_button_container">
                        <Button
                            className="cus-seconday-bg-btn top-btn FilterButton"
                            onClick={() => setShowFilter(v => !v)}
                        >
                            Filter
                        </Button>
                        {cameFromPartnerMgmt && (
                            <Button
                                className="cus-primary-transparent-btn backBtn"
                                onClick={() => navigate('/partner-management')}
                            >
                                Back
                            </Button>
                        )}
                    </div>
                </div>

                <SearchProduct
                    showSearch={true}
                    searchTxt={searchInput}
                    setSearchTxt={setSearchInput}
                    handleReset={handleSearchFilter}
                    handleSearchFilter={handleSearchFilter}
                    placeHolderText="Search by Name, Email, Phone, Company, City, State, Country, ZIP, Signup Reason, Status, or Referred By"
                />

                {showFilter && (
                    <UserRequestFilterPanel
                        showFilter={showFilter}
                        initialSellers={filterSelections.sellers}
                        initialStatuses={filterSelections.statuses}
                        onApply={handleFilterApply}
                        onClear={handleFilterClear}
                    />
                )}

                {loader && (<div className="full-screen-spinner-overlay"><LoaderSpinner /></div>)}
                <div className="main_content_table_history">
                    <div className="tableFixHead pl-2 zIndex1">
                        {allPendingUsersDataStatus === 'SUCCESS' && (
                            <DataTable
                                headers={UserRequestColumns}
                                tableData={usersList}
                                actionType={8}
                                handleAction={handleAction}
                                handleSortingColumn={handleSortingColumn}
                                tableDataStatus={allPendingUsersDataStatus}
                                filterData={filterData}
                                showResetPassword={canResetPassword}
                                showEditAccountDetails={canEditAccountDetails}
                            />
                        )}
                    </div>
                </div>
                <BatchPagination
                    gridData={usersList}
                    totalVisualRecords={usersList?.length}
                    numberOfPage={filterData.pageSize}
                    numOfPage={numOfPage}
                    loader={loader}
                    currentPage={filterData.pageIndex}
                    totalPages={filterData.totalPages}
                    totalRecords={allPendingUsersData?.TotalRecords || 0}
                    setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                    setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value, pageIndex: 1 })}
                />
            </div>
            {showUserRequest.show && (
                <Dialog
                    open={showUserRequest.show}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    fullWidth
                    maxWidth="lg"
                    onClose={() => setShowUserRequest({ show: false, data: null, startInEditMode: false })}
                    scroll="paper"
                >
                    <DialogContent className="onboardingFormWrapping" dividers>
                        <UserOnboarding
                            isViewUserRequest={true}
                            data={showUserRequest.data}
                            startInEditMode={showUserRequest.startInEditMode}
                            canEditAccountDetails={canEditAccountDetails}
                            onAccountSaved={fetchAllList}
                            close={() => setShowUserRequest({ show: false, data: null, startInEditMode: false })}
                        />
                    </DialogContent>
                </Dialog>
            )}
            {resetPasswordModal.show && (
                <AlertDialogModal
                    modalShow={resetPasswordModal.show}
                    headingText="Reset Password"
                    messageText={`Are you sure you want to reset password for <b>${resetPasswordModal.item?.FullName || ''}</b> (${resetPasswordModal.item?.Email || ''}) to the default password? An email will be sent to the user.`}
                    handleYesDeleteAlert={confirmResetPassword}
                    handleCancelDeleteAlert={closeResetPasswordModal}
                    loader={resetPasswordLoader}
                />
            )}
            <RejectReasonModal
                show={rejectModal.show}
                item={rejectModal.item}
                loading={rejectLoader}
                onCancel={closeRejectModal}
                onConfirm={confirmReject}
            />
        </main>
    );
}

export default UserRequest;
